var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssaultRifleVariant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.185 34.0035L95.701 34.737C95.08 34.92 94.4575 34.455 94.4575 33.807V28.704C94.4575 28.0575 94.9825 27.5325 95.629 27.5325H98.44C99.0865 27.5325 99.6115 28.0575 99.6115 28.704V32.0955C99.6115 32.9775 99.031 33.753 98.1865 34.0035H98.185Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.368 16.299C113.368 16.299 115.894 21.792 112.327 32.3505",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.612 16.299V19.9995H107.718",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.612 19.9995L113.28 22.0049V23.919L112.818 25.5165H85.495C85.495 25.5165 84.124 25.5045 84.013 23.919C83.9035 22.3335 84.013 22.0049 84.013 22.0049C84.013 22.0049 84.1345 21.0179 85.8565 21.0179C87.5785 21.0179 112.324 20.8575 112.324 20.8575",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7998 17.862H31.7028C31.1121 17.862 30.6333 18.3405 30.6333 18.9307C30.6333 19.521 31.1121 19.9995 31.7028 19.9995H63.7998C64.3905 19.9995 64.8693 19.521 64.8693 18.9307C64.8693 18.3405 64.3905 17.862 63.7998 17.862Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3528 18.6044H20.8513C20.4661 18.6044 20.1538 18.9167 20.1538 19.3019V19.3034C20.1538 19.6887 20.4661 20.0009 20.8513 20.0009H25.3528C25.738 20.0009 26.0503 19.6887 26.0503 19.3034V19.3019C26.0503 18.9167 25.738 18.6044 25.3528 18.6044Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8073 19.9125C28.1444 19.9125 28.4178 19.6391 28.4178 19.302C28.4178 18.9648 28.1444 18.6915 27.8073 18.6915C27.4701 18.6915 27.1968 18.9648 27.1968 19.302C27.1968 19.6391 27.4701 19.9125 27.8073 19.9125Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5647 14.9415C31.7544 14.9415 31.9082 14.7877 31.9082 14.598C31.9082 14.4082 31.7544 14.2545 31.5647 14.2545C31.375 14.2545 31.2212 14.4082 31.2212 14.598C31.2212 14.7877 31.375 14.9415 31.5647 14.9415Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0491 14.9415C35.2388 14.9415 35.3926 14.7877 35.3926 14.598C35.3926 14.4083 35.2388 14.2545 35.0491 14.2545C34.8594 14.2545 34.7056 14.4083 34.7056 14.598C34.7056 14.7877 34.8594 14.9415 35.0491 14.9415Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4526 27.1905H32.8951C32.524 27.1905 32.2231 27.4914 32.2231 27.8625C32.2231 28.2336 32.524 28.5345 32.8951 28.5345H50.4526C50.8238 28.5345 51.1246 28.2336 51.1246 27.8625C51.1246 27.4914 50.8238 27.1905 50.4526 27.1905Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9644 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0066 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0493 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0913 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1343 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1765 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2192 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2612 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.304 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3462 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3889 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4312 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4741 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5149 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5571 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6001 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6421 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6851 28.884V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0718 25.2525V32.0715",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9106 25.929V30.9495",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1401 26.01H70.7456V23.46H71.5466H74.1401V26.01Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9087 26.01V23.46",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M72.978 26.01V23.46",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M102.573 31.3605V33.6225V37.7385H104.137L106.524 36.6675V31.3605",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M106.524 32.6566H102.573",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M106.524 33.8085H102.573",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M106.524 34.9605H102.573",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M106.524 36.1125H102.573",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5444 26.5455H89.9824C89.9824 26.5455 92.5339 26.505 92.5339 28.0275V34.077C92.5339 34.077 92.5744 36.2985 90.0244 37.122C87.4729 37.9455 86.0734 38.274 86.0734 38.274H83.0284L80.7169 41.0925",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6723 27.0945C93.8313 27.0945 93.9603 26.9656 93.9603 26.8065C93.9603 26.6474 93.8313 26.5185 93.6723 26.5185C93.5132 26.5185 93.3843 26.6474 93.3843 26.8065C93.3843 26.9656 93.5132 27.0945 93.6723 27.0945Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6723 36.2429C93.8313 36.2429 93.9603 36.114 93.9603 35.9549C93.9603 35.7959 93.8313 35.6669 93.6723 35.6669C93.5132 35.6669 93.3843 35.7959 93.3843 35.9549C93.3843 36.114 93.5132 36.2429 93.6723 36.2429Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8227 40.0289C83.9817 40.0289 84.1107 39.9 84.1107 39.7409C84.1107 39.5819 83.9817 39.4529 83.8227 39.4529C83.6636 39.4529 83.5347 39.5819 83.5347 39.7409C83.5347 39.9 83.6636 40.0289 83.8227 40.0289Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0308 41.3295C91.054 41.3295 91.0728 41.3107 91.0728 41.2875C91.0728 41.2643 91.054 41.2455 91.0308 41.2455C91.0076 41.2455 90.9888 41.2643 90.9888 41.2875C90.9888 41.3107 91.0076 41.3295 91.0308 41.3295Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5786 21.7305C74.6018 21.7305 74.6206 21.7117 74.6206 21.6885C74.6206 21.6653 74.6018 21.6465 74.5786 21.6465C74.5554 21.6465 74.5366 21.6653 74.5366 21.6885C74.5366 21.7117 74.5554 21.7305 74.5786 21.7305Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6724 23.1315C93.6956 23.1315 93.7144 23.1127 93.7144 23.0895C93.7144 23.0664 93.6956 23.0475 93.6724 23.0475C93.6492 23.0475 93.6304 23.0664 93.6304 23.0895C93.6304 23.1127 93.6492 23.1315 93.6724 23.1315Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M107.428 23.1315C107.451 23.1315 107.47 23.1127 107.47 23.0895C107.47 23.0664 107.451 23.0475 107.428 23.0475C107.405 23.0475 107.386 23.0664 107.386 23.0895C107.386 23.1127 107.405 23.1315 107.428 23.1315Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7026 17.904C70.7258 17.904 70.7446 17.8852 70.7446 17.862C70.7446 17.8388 70.7258 17.82 70.7026 17.82C70.6794 17.82 70.6606 17.8388 70.6606 17.862C70.6606 17.8852 70.6794 17.904 70.7026 17.904Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9546 17.904C67.9778 17.904 67.9966 17.8852 67.9966 17.862C67.9966 17.8388 67.9778 17.82 67.9546 17.82C67.9314 17.82 67.9126 17.8388 67.9126 17.862C67.9126 17.8852 67.9314 17.904 67.9546 17.904Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9976 22.596C71.0208 22.596 71.0396 22.5772 71.0396 22.554C71.0396 22.5308 71.0208 22.512 70.9976 22.512C70.9744 22.512 70.9556 22.5308 70.9556 22.554C70.9556 22.5772 70.9744 22.596 70.9976 22.596Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2506 12.5685L19.2886 15.312",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18799 18.93H8.87849",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11.019 16.6785C11.019 16.6785 9.25046 18.4305 10.731 21.0075",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0465 16.6785C12.0465 16.6785 10.524 18.7275 12.0465 21.1965",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1309 17.3415C13.1309 17.3415 12.2834 19.2435 13.0499 20.5695",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5864 17.82V20.3115",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6201 7.1745C56.6201 7.1745 55.9931 9.303 55.6631 9.633C55.3331 9.963 49.6421 9.9345 49.6421 9.9345",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4819 12.816H62.2894",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5149 12.3075H48.0104L49.0949 13.296L49.3409 15.7515",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1245 14.598H54.9105H63.63",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9106 15.723V14.598",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5454 14.598V15.723",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6147 19.9995L61.2197 21.072H67.3922L69.7787 19.551H83.8232",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5444 22.2795L71.3839 20.538H82.7119V22.005H80.3959C80.3959 22.005 77.8864 21.813 77.8864 23.4585V25.104H74.1424",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8374 22.512H106.276",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8374 23.766H106.276",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7769 22.512H92.5339",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7769 23.7661H92.5339",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M108.458 22.512H109.665",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M108.458 23.766H109.665",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8996 20.997C89.8996 20.997 88.7476 21.003 88.7476 22.05V24.3255C88.7476 24.3255 88.9126 25.5165 89.9416 25.5165",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M112.326 21.237L111.612 22.005V24.117L112.161 24.735V25.5165",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1978 18.768H90.7362",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1978 17.6714H90.0508",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1978 16.602H89.4748",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74758 16.6831C3.78358 16.6411 12.2511 16.6831 12.2511 16.6831L13.1286 17.3416H15.8166L18.6141 16.6831L19.4376 15.3121H18.4506C18.4506 15.3121 17.6271 14.7091 17.5731 13.7761C17.5176 12.8431 18.1221 12.5686 18.1221 12.5686H21.2496L22.2921 11.1976L33.4296 9.9361C33.4296 9.9361 42.7566 8.5096 46.3221 9.0586V10.1011L49.3401 9.8821V7.7971L56.3631 6.6991L56.7471 7.4116L60.6981 6.6991L63.6606 12.8446L61.9596 12.9001L64.9776 15.9721L83.9331 15.8071V14.4901L95.0436 14.2426C95.0436 14.2426 100.147 15.0661 103.768 15.1486C107.389 15.2311 108.376 15.2311 108.376 15.2311L109.199 15.7246L111.586 15.8896L114.466 15.9721C114.466 15.9721 116.441 15.4786 116.935 17.7001C117.428 19.9216 116.935 22.6381 116.935 22.6381C116.935 22.6381 116.606 24.4486 116.029 26.8351C115.453 29.2216 115.205 31.5076 113.642 32.0926C112.079 32.6776 111.091 32.0926 111.091 32.0926C111.091 32.0926 107.881 31.8856 107.717 31.1296L107.635 32.7916L109.528 34.3246L109.363 36.4636L100.31 40.4146C100.31 40.4146 98.2521 40.9906 96.6891 41.0731C95.1261 41.1556 92.4096 41.0731 92.4096 41.0731L92.2446 42.1426C92.2446 42.1426 89.5281 43.4311 87.9651 43.6921C86.4021 43.9531 82.2861 43.6921 82.2861 43.6921C82.2861 43.6921 80.2281 40.3321 80.1471 40.0846C80.0661 39.8371 80.5041 38.7946 80.0646 38.2471C79.6251 37.6981 78.9666 37.4236 78.9666 37.1491C78.9666 36.8746 79.0221 36.0511 78.6921 35.5576C78.3636 35.0641 77.4846 34.6246 77.4306 34.2406C77.3751 33.8566 77.4306 32.9791 77.2116 32.4856C76.9926 31.9921 76.1136 31.6621 76.1136 31.6621L70.1331 31.6066L67.9941 30.2896L57.2406 30.3451L57.0756 31.2781L55.9776 31.3336L55.1541 30.9496L53.6721 32.2111L29.1471 32.0461C29.1471 32.0461 28.2696 31.3336 28.2696 30.3451L26.0196 30.2896L25.4166 29.1916L23.9346 29.6311L21.4656 29.5756C21.4656 29.5756 20.8071 28.4776 20.8626 27.4366C20.9181 26.3941 21.3561 25.9546 21.3561 25.9546L24.3186 25.7896C24.3186 25.7896 23.6601 24.1441 23.4411 23.7046C23.2221 23.2651 23.2221 22.5526 23.2221 22.5526H18.7236L18.4491 21.3451L17.6811 21.2896L15.9261 20.3026L13.2921 20.3581L12.5241 21.0166L3.74608 20.9611C3.74608 20.9611 1.88008 18.8761 3.74608 16.6816L3.74758 16.6831Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4524 21.3466C18.1239 18.3286 18.6174 16.6831 18.6174 16.6831H28.8774",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4293 9.93457V15.3106C33.4293 15.3106 33.4293 15.8596 32.7168 15.9691C32.0043 16.0786 29.7543 15.9691 29.7543 15.9691C29.7543 15.9691 28.8213 15.9691 28.8768 16.6816C28.9323 17.3941 28.8738 17.7796 28.8738 17.7796L29.5338 18.4381V20.0836L28.8738 21.0166V22.4986C28.8738 22.4986 28.8768 23.7601 30.0828 23.8696C31.2888 23.9791 58.2828 23.8696 58.2828 23.8696L60.8073 22.4986",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3224 10.0996V12.3496C46.3224 12.3496 45.5544 12.9526 45.5544 13.6111V15.7501",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7175 15.9706H65.4715",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3396 9.88062C49.3396 9.88062 50.3821 12.9526 50.8216 12.9256C51.2611 12.8986 51.4801 13.1731 51.4801 13.1731L50.4106 15.7516",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M83.933 15.8056C83.933 15.8056 83.6855 18.8236 83.933 19.2616C84.1805 19.7011 84.839 19.9201 85.9355 19.9741C87.032 20.0281 107.278 19.9741 107.278 19.9741C107.278 19.9741 108.704 19.6996 108.813 18.9316C108.923 18.1636 108.813 15.7216 108.813 15.7216",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9981 35.2831H85.8086C85.3001 35.2831 84.8456 34.9726 84.6776 34.5076L82.7786 29.2846C82.5086 28.5436 83.0771 27.7666 83.8901 27.7666H87.8021C88.4681 27.7666 89.0081 28.2886 89.0081 28.9336V33.3391C89.0081 34.4131 88.1081 35.2831 86.9981 35.2831V35.2831Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1271 27.5326H71.3786C70.6322 27.5326 70.0271 28.1373 70.0271 28.8833C70.0271 29.6293 70.6322 30.2341 71.3786 30.2341H75.1271C75.8735 30.2341 76.4786 29.6293 76.4786 28.8833C76.4786 28.1373 75.8735 27.5326 75.1271 27.5326Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M116.834 17.3416C116.561 15.8191 114.466 15.9706 114.466 15.9706L109.199 15.7231L108.376 15.2296C108.376 15.2296 106.154 15.1981 105.908 15.1921C105.661 15.1876 100.558 14.9401 100.558 14.9401L95.0436 14.2411L83.9331 14.4886V15.8056L65.4711 15.9706L64.3611 15.3436L62.2896 12.8161L63.4026 12.3091L60.4086 7.17612L56.7486 7.41312L56.3646 6.70062L49.3416 7.79862L49.6431 9.93762L46.3236 10.1026V9.06012L42.5991 8.97462L39.2181 9.22512L22.2921 11.1991L21.2496 12.5701H18.1221C17.0796 13.6951 18.4506 15.3136 18.4506 15.3136L19.2876 15.7246L18.3381 16.6021L15.5841 17.3431H13.1286L12.2511 16.6846H3.74762C1.82762 19.2901 3.74762 20.9641 3.74762 20.9641L12.0456 21.1966L13.2936 20.3596L15.9276 20.3041L18.4521 21.3466L18.7266 22.5541H23.2251L24.3231 25.7911L23.6076 25.8331L21.3591 25.9561C21.3591 25.9561 21.0666 26.4586 20.8656 27.4381C20.6646 28.4161 21.4686 29.5771 21.4686 29.5771L23.9376 29.6326L25.4196 29.1931L26.0226 30.2911L28.2726 30.3466L29.1501 32.0476L53.6751 32.2126L55.1571 30.9511L55.9806 31.3351L57.0786 31.2796L57.2436 30.3466L67.9971 30.2911L70.1361 31.6081L76.1166 31.6636L77.2146 32.4871L77.4336 34.2421L78.6951 35.5591L78.9696 37.1506L80.0676 38.2486L80.1501 40.0861L81.2631 42.0031L82.7136 43.8091C82.7136 43.8091 86.9766 43.7851 87.5571 43.6936C88.1376 43.6021 89.7786 43.1731 89.7786 43.1731L91.9071 42.3001L92.4126 41.0731C92.4126 41.0731 96.0366 41.0971 97.8501 40.9456C99.6636 40.7941 100.561 40.3066 100.561 40.3066L106.528 37.7401L109.367 36.4651L109.514 34.5511L107.639 32.7916L107.722 31.5271L110.846 32.0746C110.846 32.0746 112.496 32.7616 113.648 32.0941C114.8 31.4266 115.084 30.4801 115.084 30.4801C115.084 30.4801 116.843 23.1466 117.1 21.3496C117.356 19.5526 117.113 18.8671 116.84 17.3446L116.834 17.3416ZM75.1266 30.2356H71.3781C70.6326 30.2356 70.0266 29.6311 70.0266 28.8841C70.0266 28.1371 70.6311 27.5326 71.3781 27.5326H75.1266C75.8721 27.5326 76.4781 28.1371 76.4781 28.8841C76.4781 29.6311 75.8736 30.2356 75.1266 30.2356ZM89.0076 33.3376C89.0076 34.4116 88.1076 35.2816 86.9976 35.2816H85.8081C85.2996 35.2816 84.8451 34.9711 84.6771 34.5061L82.7781 29.2831C82.5081 28.5421 83.0766 27.7651 83.8896 27.7651H87.8016C88.4676 27.7651 89.0076 28.2871 89.0076 28.9321V33.3376V33.3376Z",
    fill: "#FAFAFB"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0755 31.2781V26.6146C57.0755 26.6146 56.9105 25.7911 56.3075 25.7911H54.9905L54.278 25.2526H29.5895C29.5895 25.2526 27.56 26.0116 28.2725 30.3451",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8738 22.0051L68.5428 22.2796V30.6271",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2251 22.5541L28.8741 22.4986",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M24.322 25.7911L25.42 29.1931",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M107.717 31.1281H102.286C102.286 31.1281 101.024 30.9481 100.969 32.4301C100.913 33.9121 100.969 36.4351 100.969 36.4351L84.3445 42.3061V43.6906",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssaultRifleVariant);
export default __webpack_public_path__ + "static/media/Assault Rifle Variant.4d87f03b29cd90bfc4541ca3e3f60c2e.svg";
export { ForwardRef as ReactComponent };